import { useContext } from 'react'
import { SLLContext } from '@contexts/ScreenLockerLoad'

export const useScreenLocker = () => useContext(SLLContext)
